import { SuburbInZipCodeEntity } from '../../entities';

export default class SuburbsInZipCodeState {
  suburbs: Array<SuburbInZipCodeEntity> = [];

  zip_code: null | string = null;
}
